var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('div',[_c('img',{attrs:{"src":_vm.staticAssets.ImgObj.right_icon,"alt":""}})]),_c('div',{staticClass:"font"},[_vm._v(_vm._s(_vm.TLang('缺票登记成功','my')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }